import { TEMPLATE_TYPES } from 'cpool-constants';
import { z } from 'zod';

import { schemaBasicMailTemplate } from './schemaBasicMailTemplate';

export const schemaSystemMailTemplate = schemaBasicMailTemplate.merge(
    z.object({
        type: z.literal(TEMPLATE_TYPES.SYSTEM_MAIL),
    }),
);

export type SchemaSystemMailTemplate = z.infer<typeof schemaSystemMailTemplate>;
